// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"531":"css/base.css","936":"js/bundle.js"}[chunkId] + ".css";
};